import { assert_false } from '@shared/asserts/utils_asserts';
import { DTO__generation_tool } from '@shared/dto/generation/DTO__generation_tool';
import { FIELD__base } from '../../../_fields/_base/FIELD__base';
import { ENUM__invocation_role as ENUM } from '../../../_invocations/_base/ENUM__invocation_role';
import { INVOCATION_GRID2D__view } from '../../../_invocations/grid2d/INVOCATION_GRID2D__view';
import { INVOCATION_IMAGE__create_mask_gradient } from '../../../_invocations/image/INVOCATION_IMAGE__create_mask_gradient';
import { INVOCATION_IMAGE__paste_with_mask } from '../../../_invocations/image/INVOCATION_IMAGE__paste_with_mask';
import { INVOCATION_IMAGE__viewport } from '../../../_invocations/image/INVOCATION_IMAGE__viewport';
import { INVOCATION_SD__denoise_latents_pipeline } from '../../../_invocations/sd/denoise/INVOCATION_SD__denoise_latents_pipeline';
import { INVOCATION_SD__image_to_latents } from '../../../_invocations/sd/vae/INVOCATION_SD__image_to_latents';
import { INVOCATION_SD__latents_to_image } from '../../../_invocations/sd/vae/INVOCATION_SD__latents_to_image';
import { ENUM__graph_template_name } from '../ENUM__graph_template_name';

export function GENERATION_TOOL__sd1__img2img(tool: DTO__generation_tool) {
  let { graph } = tool;

  assert_false(graph.is_stub());

  /*
   * GRID2D
   */
  const node__grid2d = INVOCATION_GRID2D__view.create_node_for(graph);

  /*
   * DENOISE
   */

  const node__denoise = INVOCATION_SD__denoise_latents_pipeline.create_node_for(graph, ENUM.CORE__DENOISE);

  const node__latents_to_image = INVOCATION_SD__latents_to_image.create_node_for(graph, ENUM.CORE__LATENTS_TO_IMAGE);

  /*
   * IMAGE TO LATENTS
   */

  const node__image_to_latents = INVOCATION_SD__image_to_latents.create_node_for(graph, ENUM.CORE__IMAGE_TO_LATENTS);

  let edge_to_latents = graph.edge__try_add_for_fields(node__image_to_latents.out__tensor_latents, node__denoise.latents);

  let edge_to_latents_under_mask = graph.edge__try_add_for_fields(node__image_to_latents.out__tensor_latents__under_mask, node__denoise.latents_under_mask);

  graph.edge__try_add_for_fields(node__image_to_latents.out__tensor_image__mask, node__denoise.tensor_image__mask);

  /*
   * MASK
   */
  let node__viewport = INVOCATION_IMAGE__viewport.create_node_for(graph, ENUM.CORE__IMAGE_VIEWPORT);

  graph.edge__try_add_for_fields(node__viewport.out__image_cropped, node__image_to_latents.image);
  graph.edge__try_add_for_fields(node__viewport.out__image_cropped, node__image_to_latents.image_under_mask);

  /*
   * MASK GRADIENT
   */

  let node__image_mask_gradient = INVOCATION_IMAGE__create_mask_gradient.create_node_for(graph, ENUM.IMAGE__MASK__CREATE_GRADIENT);

  graph.edge__try_add_for_fields(node__viewport.out__image_mask_cropped, node__image_mask_gradient.image_mask);
  graph.edge__try_add_for_fields(node__image_mask_gradient.out__image_mask_gradient, node__image_to_latents.image_mask);

  /*
   *
   */

  let node__image_paste = INVOCATION_IMAGE__paste_with_mask.create_node_for(graph, ENUM.IMAGE__PASTE_WITH_MASK);

  graph.edge__try_add_for_fields(node__image_to_latents.image, node__image_paste.image_source);
  graph.edge__try_add_for_fields(node__latents_to_image.out, node__image_paste.image_target);
  graph.edge__try_add_for_fields(node__image_to_latents.image_mask, node__image_paste.image_mask);

  graph.edge__try_add_for_fields(node__image_paste.out__image, node__grid2d.image);

  /*
   * UI
   */

  //todo;review and mb use
  // edge_to_latents.ui__is_visible = true;
  // edge_to_latents_under_mask.ui__is_visible = true;

  let fields__visible: FIELD__base[] = [node__viewport.image, node__denoise.denoising_strength, node__denoise.denoising_start, node__denoise.denoising_end];

  let field_column_id = node__denoise.denoising_strength.meta.field_id;

  tool.view__add({
    name: ENUM__graph_template_name.TUNE_GENERATION_LEVEL,
    group: '0. Base',

    //
    fields__visible,
    fields__stored: fields__visible,
    //
    field_column_id,
    //
    field_id_info__has_affect_on_generation: node__viewport.image.meta.field_id,
  });
}
